// src/components/admin/AdminTopbar.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, LogOut, Menu } from "lucide-react"; // 🔹 Menu 아이콘 추가
import api from "../../api/axios";

export default function AdminTopbar({ onToggleSidebar }) {
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("관리자");
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user");
      if (!raw) return;

      const user = JSON.parse(raw);
      const name = user?.name || user?.email || user?.username || "관리자";
      setDisplayName(name);
    } catch (e) {
      console.error("Failed to parse user from sessionStorage:", e);
    }
  }, []);

  const handleLogout = async () => {
    const ok = window.confirm("로그아웃 하시겠습니까?");
    if (!ok) return;

    setLoggingOut(true);
    try {
      await api.post("/api/user/logout");
      sessionStorage.removeItem("user");
      localStorage.removeItem("adminAccessToken");
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed:", err);
      sessionStorage.removeItem("user");
      localStorage.removeItem("adminAccessToken");
      navigate("/login", { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <header className="w-full border-b bg-[#0f172a]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 text-white">
        <div className="flex items-center gap-3">
          {/* 🔹 모바일 전용 메뉴 버튼 */}
          {onToggleSidebar && (
            <button
              type="button"
              onClick={onToggleSidebar}
              className="mr-1 inline-flex items-center justify-center rounded-md p-2 text-slate-200 hover:bg-slate-700 md:hidden"
              aria-label="관리자 메뉴 열기"
            >
              <Menu className="h-5 w-5" />
            </button>
          )}

          <img
            src="/assets/logo_ktsf.svg"
            alt="로고"
            className="h-7 w-auto"
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
          <Link to="/admin">
            <strong className="text-base md:text-lg">PROBEIT</strong>
          </Link>
        </div>

        <div className="flex items-center gap-3 text-sm">
          <Link
            to="/"
            className="hidden text-slate-300 hover:text-white md:inline-block"
          >
            사용자 페이지
          </Link>

          <div className="hidden items-center gap-2 rounded-full bg-slate-800/60 px-3 py-1.5 md:flex">
            <User className="h-4 w-4 text-slate-300" />
            <span className="text-slate-200">{displayName}님</span>
          </div>

          {/* 모바일/데스크톱 공통 로그아웃 버튼 (조금 줄여서) */}
          <button
            type="button"
            onClick={handleLogout}
            disabled={loggingOut}
            className="inline-flex items-center gap-2 rounded-lg bg-slate-700 px-3 py-1.5 text-xs md:text-sm text-slate-100 hover:bg-slate-600 disabled:opacity-60"
          >
            <LogOut className="h-4 w-4" />
            {loggingOut ? "로그아웃 중..." : "로그아웃"}
          </button>
        </div>
      </div>
    </header>
  );
}
